<template></template>
<script>
import {getWithoutAuth} from '../../js/services/editor/page';

export default {
  name: 'Redirector',
  created() {
    const encodeDataToURL = data => {
      return Object.keys(data)
        .map(value => `${value}=${encodeURIComponent(data[value])}`)
        .join('&');
    };

    let queryParams = '';

    if (Object.keys(this.$route.query).length > 0) {
      queryParams = '?' + encodeDataToURL(this.$route.query);
    }

    getWithoutAuth(this.$route.params.id_page).then(data => {
      let pageURL = data.data.url;

      if (data.data.layout.website.dominio == null) {
        let dominio = typeof process.env.PREMIUN_DOMAIN !== 'undefined' ? `${process.env.PREMIUN_DOMAIN}/` : '.site.builderallsite.com/';

        window.location = `https://${data.data.userEditor.subdominio}-${data.data.layout.website.url}${dominio}${pageURL}${queryParams}`;
      } else {
        window.location = `https://${data.data.layout.website.dominio}/${pageURL}${queryParams}`;
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/external/Redirector.vue